import { IntegrationLayer } from 'src/types.d';

const useIntegrationLayer = (): IntegrationLayer => (window as any).integrationLayer;

export default useIntegrationLayer;
